import {useCallback, useState} from "react";
import {BreadcrumbsType} from "@/app/components/breadcrumbs/widget";
import useWatchUrlParam from "@/app/utils/use_watch_url_param";
import {SearchParamsKey} from "@/app/utils/use_search_params";
import {OpenMatchModelResponse, OpenMatchRequests, OpenMatchStatusEnum} from "@/app/api/open_match";
import {SkillLevelEnum} from "@/app/api/user";

interface ScreenState {
  hasError?: string;
  hasLoading: boolean;
  items?: Array<BreadcrumbsType | string>;
  matches?: OpenMatchModelResponse[];
}

const useFindPlayers = () => {
  const [state, setState] = useState<ScreenState>({
    hasError: undefined,
    hasLoading: true,
    items: [BreadcrumbsType.padel, BreadcrumbsType.findPlayers],
    matches: []
  });

  const updateState = useCallback((updates: Partial<ScreenState>) => {
    setState((prev) => ({...prev, ...updates}));
  }, []);

  useWatchUrlParam(SearchParamsKey.userName, (newValue, oldValue) => {
    if (newValue !== null) {
      updateState({
        items: [BreadcrumbsType.findPlayers, newValue]
      })
    } else {
      updateState({
        items: [BreadcrumbsType.findPlayers]
      })
    }
  })

  const getNearMatches = useCallback(async () => {
    const req: OpenMatchRequests = {
      status: OpenMatchStatusEnum.NOT_STARTED,
      filterByDistance: true
    }

    const matches = await OpenMatchRequests.getMatches(req);
    updateState({matches})
  }, [updateState]);

  return {
    state,
    getNearMatches
  };
};

export default useFindPlayers;